/*
 * Copyright (c) 2024 Paul Ostrowski. All rights reserved.
 *
 * This software is the proprietary information of Paul Ostrowski.
 * Unauthorized copying, modification, or distribution of this code, via any medium, is strictly prohibited.
 * This code is proprietary and confidential.
 *
 * For licensing inquiries, contact Paul Ostrowski at postrowski@gmail.com.
*/

class AttributeValues {
    strength:     number = 10;
    dexterity:    number = 10;
    constitution: number = 10;
    intelligence: number = 10;
    wisdom:       number = 10;
    charisma:     number = 10;
}

export default AttributeValues;